import React from 'react';
import LinkedinImg from '../assets/linkedin_logo_icon_189225.png';
import GitImg from '../assets/github_logo_icon_143772.png';
import twitterImg from '../assets/twitter_logo_icon_186891.png';
import '../components/styles.css'

const ContactMe = () => {
  return (
    <div className="content-container">
    <div className="container-fluid text-light">
      <h1 className="text-center mb-4">Contact Me</h1>
      <div className="row justify-content-center">
        <div className="col-md-6">
          <h3>Contact Information</h3>
          <p>
            <strong>Email:</strong> mehmetgovori@gmail.com
          </p>
          <p>
            <strong>Phone:</strong> +38344424467
          </p>
          <p>
            <strong>Location:</strong> Prishtin,Kosov
          </p>
          <h3>Social Media</h3>
          <ul className="list-unstyled row">
            <li className='col-md-3'>
              <a className='fs-5 text-decoration-none text-warning' href="https://www.linkedin.com/in/mehmet-govori-85a30a22a/" target="_blank" rel="noopener noreferrer">
                LinkedIn <img src={LinkedinImg} alt="" />
              </a>
            </li>
            <li className='col-md-3'>
              <a className='fs-5 text-decoration-none text-warning' href="https://github.com/Metigovori" target="_blank" rel="noopener noreferrer">
                GitHub <img src={GitImg} alt="" />
              </a>
            </li>
            <li className='col-md-3 mb-5'>
              <a className='fs-5 text-decoration-none text-warning' href="https://twitter.com/" target="_blank" rel="noopener noreferrer">
                Twitter <img src={twitterImg} alt="" />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    </div>
  );
};

export default ContactMe;
